import { atom } from 'jotai';

export const isUpdateRequiredState = atom<boolean>(false);
